import isLinkSelected from './is-link-selected';
import isActiveList from './is-active-list';
import isUnderlineSelected from './is-underline-selected';

export default {
  isLinkSelected,
  isActiveList,
  isUnderlineSelected,
};
